/**
 * Simple class defining basic attributes of the geometrical section line.
 * @class DataLine
 */
export default class DataLine {
  constructor (opts) {
    opts = opts || {};

    this.section_name           = opts.section_name           || '';
    this.start_row              = opts.start_row              || '';
    this.end_row                = opts.end_row                || '';
    this.start_seat             = opts.start_seat             || '';
    this.end_seat               = opts.end_seat               || '';
    this.map_to_x               = opts.map_to_x               || 0;
    this.map_to_y               = opts.map_to_y               || 0;
    this.element_type           = opts.element_type           || '';
    this.id                     = opts.id                     || '';
    this.row_step               = opts.row_step               || 1;
    this.seat_step              = opts.seat_step              || 1;
    this.seat_inc               = opts.seat_inc               || 0;
    this.row_inc                = opts.row_inc                || 0;
    this.seat_selection_reverse = opts.seat_selection_reverse || 0;
    this.rows                   = opts.rows                   || [];
    this.seats                  = opts.seats                  || [];
    this.rows_id                = opts.rows_id                || [];
    this.seats_id               = opts.seats_id               || [];
    this.avail_section_id       = opts.avail_section_id       || [];
  }
}



// WEBPACK FOOTER //
// ./frontend/react/sim/schemas/Line.js